import "@/util/extends/toFirstUpperCase";
import router from "@/router/index";
import { api } from "@/api/index";
import axios from "axios";

//通用模块状态控制
const authModule = {
  state: {
    osskey: {},
    sysPlatform: "YJXD", //oss管理系统平台标识
    businussType: "Public", //业务类型  这里暂定为公开类型
  },

  //激发事件改变state
  mutations: {
    setOssKey(state, data) {
      state.osskey = data;
    },
  },

  //异步操作拿远程数据,然后提交事件
  actions: {
    GET_OSSKEY: async ({ commit, state }, { ...params }) => {
      try {
        let res = await api.system.getOssToken();
        if (res.status && res.data) {
          commit("setOssKey", res.data);
        }
      } catch (err) {
        console.log(err, "获取权限异常");
      }
    },
  },
};

export default authModule;



// WEBPACK FOOTER //
// ./src/store/modules/oss.js